import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode, setMode, setColorTheme, setColorMode } from './themeSlice';
import type { ThemeMode, ColorTheme, ColorMode, ThemeState } from './types';

type RootWithTheme = { theme: ThemeState };

export function useTheme() {
  const dispatch = useDispatch();
  const { mode, colorTheme, colorMode } = useSelector((s: RootWithTheme) => s.theme);

  return {
    mode,
    colorTheme,
    colorMode,
    isDark: mode === 'dark',
    toggleMode: useCallback(() => dispatch(toggleMode()), [dispatch]),
    setMode: useCallback((m: ThemeMode) => dispatch(setMode(m)), [dispatch]),
    setColorTheme: useCallback((t: ColorTheme) => dispatch(setColorTheme(t)), [dispatch]),
    setColorMode: useCallback((m: ColorMode) => dispatch(setColorMode(m)), [dispatch]),
  };
}
